export const dateFilterOptions = [
  { name: "Today", value: "today" },
  { name: "Yesterday", value: "yesterday" },
  { name: "Last 7 days", value: "week" },
  { name: "Last 30 days", value: "month" }
];

export const statusFilterOptions = [
  { name: "All Status", value: "all" },
  { name: "Sent", value: "sent" },
  { name: "Queued", value: "queued" },
  { name: "Processing", value: "processing" },
  { name: "Failed", value: "failed" }
];
